import React, { Component } from 'react'

const classOtpTimer = {
    color: '#fe1110',
    fontSize: '12px',
    fontWeight: '600',
}

let intervalId = 0;

export default class OtpTimer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timer: '03:00',
            counter: this.props.timerFor * 60,
        };
    }

    updateTimer = () => {

        var counter = this.state.counter - 1;

        if (counter <= 0) {
            clearInterval(intervalId);
            //callback function call on closed timer
            this.props.onTimerClose();
        }

        var minutes = Math.floor(counter / 60);
        if (minutes < 10) minutes = "0" + minutes;

        var seconds = counter % 60;
        if (seconds < 10) seconds = "0" + seconds;

        var timer = minutes + ':' + seconds;

        this.setState({ counter: counter, timer: timer });
    }

    componentDidMount = () => {
        this.setState({ counter: this.props.timerFor * 60, timer: '03:00' });
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(this.updateTimer, 1000);
    }

    render() {
        return (
            <span style={classOtpTimer}>{this.state.timer}</span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/otpTimer/OtpTimer.js